import { render, staticRenderFns } from "./InvestmentFilesMobile.vue?vue&type=template&id=5cd4afb5"
import script from "./InvestmentFilesMobile.vue?vue&type=script&lang=js"
export * from "./InvestmentFilesMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports